import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment, MyHttpClientFactory } from '@ups/xplat/core';
import {
  ReplayUserQuerySource,
  ReplayUserRecord,
} from '@ups/xplat/web/ryn-replay';

/**
 * Software Security user-table client for the replay session list (#31260).
 *
 * web-ryn-replay has no recorder and no SS UserService; it still needs names
 * for the User column. This talks to the same `/api/userOdata` the SS app
 * uses, with the viewer's Entra token (MSAL interceptor already covers
 * first-party HTTPS APIs).
 */
@Injectable({ providedIn: 'root' })
export class ReplayUserQueryClient implements ReplayUserQuerySource {
  private readonly httpFactory = inject(MyHttpClientFactory);
  private readonly http: HttpClient | null;

  constructor() {
    const base = environment.urls?.softwareSecurityAPI?.trim();
    this.http = base ? this.httpFactory.createHttpClient(base) : null;
  }

  getUsersOdata(odataQuery: string): Observable<ReplayUserRecord[]> {
    if (!this.http) {
      return of([]);
    }
    const url = odataQuery ? `/api/userOdata?${odataQuery}` : '/api/userOdata';
    return this.http.get<ReplayUserRecord[]>(url);
  }
}
